// Sandbox-only stub, corrected to match the REAL PlanogramLockRefresher.js:
//   - default export (not named)
//   - constructor destructures { planogramId, refresh, intervalMs = 15000, logger = console }
//   - public surface: refreshNow(), start(), stop(), destroy()
//   - internally also wires visibilitychange/focus listeners that call
//     refreshNow() + restart the interval — not relevant to usePlanogramLock's
//     usage (which only calls start()/destroy()), but kept here for fidelity.
export interface PlanogramLockRefresherOptions {
    planogramId?: string;
    refresh: () => Promise<void>;
    intervalMs?: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    logger?: any;
}

class PlanogramLockRefresher {
    private planogramId?: string;
    private refresh: () => Promise<void>;
    private intervalMs: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private logger: any;
    private intervalId: ReturnType<typeof setInterval> | null = null;
    private running = false;

    constructor({ planogramId, refresh, intervalMs = 15000, logger = console }: PlanogramLockRefresherOptions) {
        this.planogramId = planogramId;
        this.refresh = refresh;
        this.intervalMs = intervalMs;
        this.logger = logger;
    }

    async refreshNow(): Promise<void> {
        if (!this.planogramId || typeof this.refresh !== 'function') return;
        try {
            await this.refresh();
            this.logger.log('Lock refreshed');
        } catch (error) {
            this.logger.error('Failed to refresh lock:', error);
        }
    }

    start(): void {
        if (this.running) return;
        this.running = true;
        this.startInterval();
    }

    stop(): void {
        this.running = false;
        this.clearInterval();
    }

    destroy(): void {
        this.stop();
    }

    private startInterval(): void {
        this.clearInterval();
        this.intervalId = setInterval(() => {
            this.refreshNow();
        }, this.intervalMs);
    }

    private clearInterval(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
}

export default PlanogramLockRefresher;